// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__204lP","error":"Textarea_error__1xtd0","readonly":"Textarea_readonly__2hba5","disabled":"Textarea_disabled__1NV44"};